import React from "react";
import "./Checkout.css"
import Subtotal from "./Subtotal";
import {useStateValue} from "./StateProvider";
import CheckoutProduct from "./CheckoutProduct"

function Checkout() {
    const [{basket,user},dispatch] = useStateValue();

    return (
       <div className="checkout">
           <div className='checkout__left'>
               <img
                   className="checkout__ad"
                   src='https://cdn.discordapp.com/attachments/781412325696733197/786094652645310464/unknown.png'
                   alt=''
                />

                <div>
                    <h3>Hello,{user?.email}</h3>
                    <h2 className='checkout__title'>Your shopping Basket  </h2>
                    {/* Basket item */}
                    {basket.map(item =>(
                        <CheckoutProduct
                            id = {item.id}
                            title={item.title}
                            image={item.image}
                            price={item.price}
                            rating={item.rating}
                        />
                    ))}

                </div>
           </div>

           <div className="checkout__right">
               <Subtotal/>


           </div>
       </div>

    );
}

export default Checkout;